import { supabase } from '../../lib/supabase'
import { getCurrentUserId } from '../../lib/auth'
import type { Notification } from '../../types/notifications'

// ============================================================
// IN-APP NOTIFICATIONS
// ============================================================

export async function getNotifications(limit: number = 50): Promise<Notification[]> {
  const userId = await getCurrentUserId()

  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(limit)

  if (error) throw error
  return data
}

export async function getUnreadNotifications(): Promise<Notification[]> {
  const userId = await getCurrentUserId()

  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .eq('user_id', userId)
    .eq('is_read', false)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

export async function getUnreadCount(): Promise<number> {
  const userId = await getCurrentUserId()

  const { count, error } = await supabase
    .from('notifications')
    .select('*', { count: 'exact', head: true })
    .eq('user_id', userId)
    .eq('is_read', false)

  if (error) throw error
  return count || 0
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  const { error } = await supabase.rpc('mark_notification_read', {
    p_notification_id: notificationId
  })

  if (error) throw error
}

export async function markAllNotificationsRead(): Promise<void> {
  const { error } = await supabase.rpc('mark_all_notifications_read')

  if (error) throw error
}
